(function () {
  const API_BASE = '/apps/wishlist';

  async function init() {
    const grid = document.getElementById('wishlist-grid');
    const emptyState = document.getElementById('wishlist-empty');
    const loading = document.getElementById('wishlist-loading');
    if (!grid) return;

    try {
      const res = await fetch(`${API_BASE}/list`, { credentials: 'same-origin' });
      if (!res.ok) {
        loading.textContent = 'Silakan login untuk melihat wishlist kamu.';
        return;
      }
      const data = await res.json();
      const items = data.items || [];

      if (items.length === 0) {
        loading.style.display = 'none';
        emptyState.style.display = 'block';
        return;
      }

      const products = await Promise.all(
        items.map(async (item) => {
          if (!item.product_handle) return null;
          try {
            const pRes = await fetch(`/products/${item.product_handle}.js`);
            if (!pRes.ok) return null;
            return await pRes.json();
          } catch {
            return null;
          }
        })
      );

      loading.style.display = 'none';

      const validProducts = products.filter(Boolean);
      if (validProducts.length === 0) {
        emptyState.style.display = 'block';
        return;
      }

      grid.innerHTML = validProducts.map(renderCard).join('');
    } catch (e) {
      console.error('Wishlist page load failed', e);
      loading.textContent = 'Gagal memuat wishlist. Coba refresh halaman.';
    }
  }

  function renderCard(product) {
    const image = product.featured_image || (product.images && product.images[0]) || '';
    const price = formatMoney(product.price);
    const compareAtPrice = product.compare_at_price;
    const url = product.url;

    return `
      <div class="wishlist-card">
        <a href="${url}" class="wishlist-card__media">
          ${image ? `<img src="${image}" alt="${escapeHtml(product.title)}" loading="lazy" width="300" height="300">` : ''}
        </a>
        <button
          type="button"
          class="wishlist-heart is-active wishlist-card__remove"
          data-wishlist-toggle
          data-product-id="${product.id}"
          data-product-handle="${product.handle}"
          aria-label="Hapus dari wishlist"
        >
          <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" stroke="currentColor" stroke-width="2">
            <path d="M12 21s-7.5-4.6-10-9.2C.5 8.4 2.4 4.5 6.2 4.1c2-.2 3.9.9 5.8 3 1.9-2.1 3.8-3.2 5.8-3 3.8.4 5.7 4.3 4.2 7.7-2.5 4.6-10 9.2-10 9.2z"/>
          </svg>
        </button>
        <div class="wishlist-card__info">
          <a href="${url}" class="wishlist-card__title">${escapeHtml(product.title)}</a>
          <div class="wishlist-card__price">
            ${compareAtPrice && compareAtPrice > product.price ? `<s>${formatMoney(compareAtPrice)}</s> ` : ''}
            ${price}
          </div>
        </div>
      </div>
    `;
  }

  function formatMoney(cents) {
    return 'Rp' + Math.round(cents / 100).toLocaleString('id-ID');
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  // When a heart is clicked on THIS page, remove the card from view
  // immediately after a successful toggle (since removing = "no longer
  // in wishlist" and there's nothing else to show for that card here).
  document.addEventListener('wishlist:toggled', (e) => {
    const grid = document.getElementById('wishlist-grid');
    if (!grid) return;
    if (e.detail.status === 'removed') {
      const card = e.detail.btn.closest('.wishlist-card');
      if (card) card.remove();
      if (!grid.querySelector('.wishlist-card')) {
        document.getElementById('wishlist-empty').style.display = 'block';
      }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
